import { decode as base64_decode, encode as base64_encode } from "base-64";

import { postApi } from "../components/Utility";
import config from "../config";
import { action, makeObservable, observable } from "mobx";

import Cookies from "js-cookie";
import utf8 from "utf8";
class CompanyStore {
  companies = [];

  logoFromDb = [];
  rec = 0;

  editedRecord_Id = "";

  total = 0;
  loading = false;
  excelLoadig = false;
  fileUploadUrl = "/company/fileUpload";

  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      companies: observable,

      logoFromDb: observable,

      editedRecord_Id: observable,

      rec: observable,

      total: observable,
      loading: observable,
      excelLoadig: observable,
      loadData: action,
      addData: action,
      editData: action,
      updateData: action,
      setEditedRecordId: action,

      getCompanyData: action,
      getSingleCompanyData: action,
      exportExcel: action,
      exportPdf: action,
      sampleExcel: action,
      setLogoFromDb: action,
      downloadTradeLicense: action,
      downloadAgreement: action,
      fileUploadUrl: observable,
    });
    this.rootStore = rootStore;
  }

  async loadData({
    offset,
    limit,
    emailId,
    status,
    company_name,
    distributorType,
    distCompanyId,
  }) {
    this.loading = true;

    var postData = {
      companyId: Number(
        JSON.parse(base64_decode(Cookies.get("data"))).userCompanyId
      ),
      cstatus: status,
      isadmin: JSON.parse(base64_decode(Cookies.get("data"))).isadmin,
      cdType: distributorType,
      distCompanyId:
        JSON.parse(base64_decode(Cookies.get("data"))).isadmin === 1
          ? Number(JSON.parse(base64_decode(Cookies.get("data"))).userCompanyId)
          : distCompanyId,
      cname: company_name,
      email: emailId,
      offset: offset,
      limit: limit,
    };

    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("/company/getCompanyList", {
        params: postData,
      });

    this.companies = response?.data?.data?.companydata;

    if (this.companies?.length > 0) {
      this.rec = 1;
    }

    this.total = parseInt(response?.data?.data?.TotalCount);
    this.loading = false;
  }

  // async loadData({
  //   offset,
  //   limit,
  //   emailId,
  //   status,
  //   company_name,
  //   distributorType,
  //   searchCompanyId,
  //   distCompanyId,
  // }) {
  //   this.loading = true;

  //   var postData = {
  //     companyId: Number(
  //       JSON.parse(base64_decode(Cookies.get("data"))).userCompanyId
  //     ),
  //     cstatus: status,
  //     isadmin: JSON.parse(base64_decode(Cookies.get("data"))).isadmin,
  //     cdType: distributorType,
  //     distCompanyId:
  //       JSON.parse(base64_decode(Cookies.get("data"))).isadmin === 1
  //         ? Number(JSON.parse(base64_decode(Cookies.get("data"))).userCompanyId)
  //         : distCompanyId,
  //     cname: company_name,
  //     email: emailId,
  //     offset: offset,
  //     limit: limit,
  //   };
  //   const base64Input = await base64_encode(JSON.stringify(postData));
  //   var response = await postApi
  //     .getClient()
  //     .post("index.php?c=company&a=newCompanyList2", "postData=" + base64Input);
  //   this.companies = response?.data?.data?.companydata;
  //   console.log(response?.data?.data?.companydata);
  //   if (this.companies?.length > 0) {
  //     this.rec = 1;
  //   }

  //   this.total = parseInt(response?.data?.data?.TotalCount);
  //   console.log(this.total);
  //   this.loading = false;
  // }

  async addData(company) {
    var postData = { company: company };
    var response = await postApi
      .getClient("NodeCoreUrl")
      .post("/company/createCompany", company);
    return response.data;
  }

  // async addData(company) {
  //   var postData = { company: company };
  //   const base64Input = await utf8.encode(JSON.stringify(postData));
  //   const base2 = JSON.stringify(base64_encode(base64Input));
  //   var response = await postApi
  //     .getClient()
  //     .post("index.php?c=company&a=create", "postData=" + base2);
  //   return response.data;
  // }

  async updateData(company) {
    var response = await postApi
      .getClient("NodeCoreUrl")
      .post("/company/updateCompany", company);
    return response.data;
  }

  // async updateData(company) {
  //   var postData = { tokenId: "80bovn8u800tg1aq9bvr73kbhh", company: company };
  //   // const base64Input = await base64_encode(JSON.stringify(postData));
  //   const base64Input = await utf8.encode(JSON.stringify(postData));
  //   const base2 = JSON.stringify(base64_encode(base64Input));
  //   var response = await postApi
  //     .getClient()
  //     .post("index.php?c=company&a=update", "postData=" + base2);
  //   return response.data;
  // }

  async editData(companyId) {
    var postData = { companyId: companyId };

    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=company&a=getCompanySingle",
        "postData=" + base64Input
      );
    console.log("editRecord", response);
    return response.data.data.companydetails;
  }

  async updateStatus(data) {
    var response = await postApi
      .getClient("NodeCoreUrl")
      .post("company/updateStatus", data);
    return response.data;
  }

  // async updateStatus(data) {
  //   //update active in-active
  //   // var postData ={ data };
  //   const base64Input = await base64_encode(JSON.stringify(data));
  //   var response = await postApi
  //     .getClient()
  //     .post("index.php?c=company&a=updateActive", "postData=" + base64Input);
  //   return response.data;
  // }

  async getSingleCompanyData(companyId) {
    var postData = { getCompanyId: companyId, limit: 10, offset: 0 };
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("/company/getCompanyList", {
        params: postData,
      });
    var singleRow = response.data.data.companydata[0];

    if (singleRow?.logo) {
      const fileList = [
        {
          name: singleRow.logo,
          status: "success",
          url: config.fleetURL + "/images/companylogo/" + singleRow.logo,
        },
      ];
      this.setLogoFromDb(fileList);
    }
    return response.data.data.companydata[0];
  }

  // async getSingleCompanyData(companyId) {
  //   console.log("edee");
  //   var postData = { getCompanyId: companyId, limit: 10, offset: 0 };

  //   const base64Input = await base64_encode(JSON.stringify(postData));
  //   var response = await postApi
  //     .getClient()
  //     .post("index.php?c=company&a=newCompanyList2", "postData=" + base64Input);

  //   var singleRow = response.data.data.companydata[0];

  //   //this.logoFromDb.disabled = true;

  //   if (singleRow?.logo) {
  //     console.log(config.fleetURL + "/images/companylogo/" + singleRow.logo);

  //     const fileList = [
  //       {
  //         name: singleRow.logo,
  //         status: "success",
  //         url: config.fleetURL + "/images/companylogo/" + singleRow.logo,
  //       },
  //     ];
  //     this.setLogoFromDb(fileList);
  //     //  }
  //     console.log(this.logoFromDb);
  //   }

  //   console.log("editRecord", response);

  //   return response.data.data.companydata[0];
  // }

  async getCompanyData(companyName, fromAccountList, showAll) {
    var postData = {
      value: companyName,
      isadmin: JSON.parse(base64_decode(Cookies.get("data"))).isadmin,
      companyId: JSON.parse(base64_decode(Cookies.get("data"))).userCompanyId,
      showAll: showAll,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("company/getCompanyDropDown", {
        params: postData,
      });
    return response.data.data.companies?.map((user) => ({
      label: user.name,
      value: user.companyId,
      fromAccountList: fromAccountList,
      contact1Email: user.contact1Email,
      contact1No: user.contact1No,
    }));
  }

  async setLogoFromDb(logo) {
    this.logoFromDb = { fileList: logo };
    console.log(logo);
  }

  async getCompanyDataById(companyId, showAll) {
    var postData = {
      value: companyId,
      getBy: "companyId",
      isadmin: JSON.parse(base64_decode(Cookies.get("data"))).isadmin,
      companyId:
        JSON.parse(base64_decode(Cookies.get("data"))).isadmin === 3
          ? companyId
          : null,
      showAll: showAll ? showAll : null,
    };
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("company/getCompanyDropDown", {
        params: postData,
      });
    return response.data.data.companies.map((user) => ({
      label: user.name,
      value: user.companyId,
    }));
  }

  // async getCompanyDataById(companyId, showAll) {
  //   // console.log(isadmin);
  //   var postData = {
  //     value: companyId,
  //     getBy: "companyId",
  //     isadmin: JSON.parse(base64_decode(Cookies.get("data"))).isadmin,
  //     companyId:
  //       JSON.parse(base64_decode(Cookies.get("data"))).isadmin === 3
  //         ? companyId
  //         : null,
  //     showAll: showAll ? showAll : null,
  //   };
  //   const base64Input = await base64_encode(JSON.stringify(postData));
  //   var response = await postApi
  //     .getClient()
  //     .post("index.php?c=company&a=getCompanyList", "postData=" + base64Input);
  //   return response.data.data.companies.map((user) => ({
  //     label: user.name,
  //     value: user.companyId,
  //   }));
  // }

  async deleteRecord({ companyId }) {
    var response = await postApi
      .getClient("NodeCoreUrl")
      .delete(`company/deleteCompany/${companyId}`);
    return response;
  }

  // async deleteRecord({ companyId }) {
  //   var postData = { company: { companyId: companyId } };
  //   console.log(postData);
  //   const base64Input = await base64_encode(JSON.stringify(postData));
  //   var response = await postApi
  //     .getClient()
  //     .post("index.php?c=company&a=delete", "postData=" + base64Input);
  //   return response;
  // }

  async setEditedRecordId(id) {
    console.log(id);
    this.editedRecord_Id = id;
    console.log(this.editedRecord_Id);
  }

  async exportExcel(getData) {
    try {
      var response = await postApi.getClient("NodeCoreUrl").post(
        "company/exportExcel",
        { postData: getData },
        {
          responseType: "blob",
        }
      );
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Company list.xlsx";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading the file", error);
    }
  }

  // async exportExcel(getData) {
  //   // window.location.href = config.baseURL + "index.php?c=vehicle&a=exportloginexcel&cid=" +getDta.companyId + '&fD=' + getDta.fromDate + '&tD=' + getDta.toDate + '&uId=' + getDta.userid + '&colList=' + getDta.colList
  //   window.location.href =
  //     config.baseURL +
  //     "index.php?c=company&a=exportCompanyExcel&dType=" +
  //     getData.dType +
  //     "&isadmin=" +
  //     getData.isadmin +
  //     "&cid=" +
  //     getData.cid +
  //     "&cType=" +
  //     getData.cType +
  //     "&cName=" +
  //     getData.cName +
  //     "&cstatus=" +
  //     getData.cstatus +
  //     "&email=" +
  //     getData.email +
  //     "&colList=" +
  //     getData.colList;
  // }

  async exportPdf(getData) {
    // window.location.href = config.baseURL + "index.php?c=vehicle&a=exportloginexcel&cid=" +getDta.companyId + '&fD=' + getDta.fromDate + '&tD=' + getDta.toDate + '&uId=' + getDta.userid + '&colList=' + getDta.colList
    // window.location.href = config.baseURL + "index.php?c=company&a=exportCompanyPdf&dType=" +getData.dType+ '&isadmin='+getData.isadmin+ '&cid='+getData.cid+ '&cType='+getData.cType +'&cName='+getData.cName + '&email='+getData.email+ '&colList='+getData.colList
    window.location.href =
      config.baseURL +
      "index.php?c=company&a=exportCompanyPdf&dType=" +
      getData.dType +
      "&isadmin=" +
      getData.isadmin +
      "&cid=" +
      getData.cid +
      "&cType=" +
      getData.cType +
      "&cName=" +
      getData.cName +
      "&email=" +
      getData.email +
      "&cstatus=" +
      getData.cstatus +
      "&colList=" +
      getData.colList;
  }

  async sampleExcel() {
    window.location.href = config.fleetURL + "/appRes/excel/companyList.xlsx";
  }

  async accountImport(excelFile, userId) {
    console.log(userId);
    this.excelLoadig = true;
    var postData = { fileName: excelFile, userId: userId };
    console.log(postData);
    console.log(this.excelLoadig);
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=company&a=importCompanyNew2",
        "postData=" + base64Input
      );
    this.excelLoadig = false;
    return response.data;
  }

  async downloadTradeLicense(fname) {
    console.log(fname);
    var response = await postApi
      .getClient()
      .post("index.php?c=company&a=downloadLicense&fname=" + fname);
  }

  async downloadAgreement(fname) {
    console.log(fname);
    var response = await postApi
      .getClient()
      .post("index.php?c=company&a=downloadagreement&fname=" + fname);
  }
}

export default CompanyStore;
